const V6 = {
  version: 'v6',

  /* Fonts and Font Sizes */
  fontFamily: 'Mark Pro, sans-serif',

  /* Grids */
  gridGap: '4px',

  /* Colors */
  primaryColor: '#000000',
  complementaryColor: '#ffffff',
  darkGrayColor: '#9b9b9b',
  bordersColor: '#e5e5e5',

  /* badge styles */
  badges: {
    fontSize: '11px',
    colors: {
      default: 'black',
      sale: 'white',
    },
    backgroundColors: {
      default: 'white',
      basket: '#70EAB4',
      sale: '#E72D34',
      campaign: '#C4262C',
    },
    fontWeight: '500',
  },
};

export type AyThemeKeys = typeof V6;

export {V6};
